import { CurrencyDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as CurrencyActions from './currency.actions';

export const CURRENCY_FEATURE_KEY = 'currency';

export interface CurrencyState extends EntityState<CurrencyDto> {
  selectedCurrencyId?: string | number; // which Currency record has been selected
  loaded: boolean; // has the Currency list been loaded
  error?: string | null; // last none error (if any)
}

export interface CurrencyPartialState {
  readonly [CURRENCY_FEATURE_KEY]: CurrencyState;
}

export const currencyAdapter: EntityAdapter<CurrencyDto> = createEntityAdapter<
  CurrencyDto
>({
  selectId: (currency) => currency.id,
  sortComparer: false,
});

export const initialState: CurrencyState = currencyAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedCurrencyId: null,
});

const currencyReducer = createReducer(
  initialState,
  on(CurrencyActions.loadCurrency, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CurrencyActions.loadCurrencySuccess, (state, { currency }) =>
    currencyAdapter.addAll(currency, { ...state, loaded: false })
  ),
  on(CurrencyActions.loadCurrencyFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CurrencyActions.addCurrency, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CurrencyActions.addCurrencySuccess, (state, { newCurrency }) =>
    currencyAdapter.addMany(newCurrency, { ...state, loaded: false })
  ),
  on(CurrencyActions.addCurrencyFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CurrencyActions.updateCurrency, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CurrencyActions.updateCurrencySuccess, (state, { updateCurrency }) =>
    currencyAdapter.upsertMany(updateCurrency, { ...state, loaded: false })
  ),
  on(CurrencyActions.updateCurrencyFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CurrencyActions.removeCurrency, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CurrencyActions.removeCurrencySuccess, (state, { ids }) =>
    currencyAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(CurrencyActions.removeCurrencyFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: CurrencyState | undefined, action: Action) {
  return currencyReducer(state, action);
}
